export class ThreadMessage {
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.sender = model.sender;
        this.body = model.body;
        this.isPrompt = (_a = model.isPrompt) !== null && _a !== void 0 ? _a : false;
        this.startsNewThread = (_b = model.startsNewThread) !== null && _b !== void 0 ? _b : false;
        this.parentMessageId = model.parentMessageId;
        this.replyToMessageId = model.replyToMessageId;
        this.attachments = model.attachments;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
        this.agentResponseTrackerId = model.agentResponseTrackerId;
        this.threadId = model.threadId;
        this.promptMetadata = model.promptMetadata;
        this.annotations = model.annotations;
    }
    toRemote() {
        var _a;
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
            updatedAt: (_a = this.updatedAt) === null || _a === void 0 ? void 0 : _a.toISOString(),
        };
    }
}
